export default {
    USER_SEARCH: 'USER_SEARCH',
    USER_POSTED: 'USER_POSTED',
    INTERNAL_JOBS: 'INTERNAL_JOBS',
    PROMOTED_JOBS: 'PROMOTED_JOBS',
    LOCATION: 'LOCATION',
    USER_SAVED: 'USER_SAVED',
};
